<template>
  <div class="loader-container">
    <div class="loader">
      <img src="logo.png" class="rotate" width="100px" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
